import { useState } from 'react'

export default function RegisterForm({ onRegister, onToggleLogin }) {
  const [formData, setFormData] = useState({ email: '', pin: '', confirmPin: '' })
  const [submitting, setSubmitting] = useState(false)
  const [touched, setTouched] = useState(false)
  const [error, setError] = useState('')

  const valid = formData.email.trim().length > 0 && formData.pin.trim().length > 0 && formData.pin === formData.confirmPin

  const submit = async (e) => {
    e.preventDefault()
    setTouched(true)
    setError('')
    if (formData.pin !== formData.confirmPin) {
      setError('Passcodes do not match')
      return
    }
    setSubmitting(true)
    setTimeout(() => {
      onRegister()
      setSubmitting(false)
    }, 300)
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-header">
          <div className="auth-title">Create account</div>
        </div>

        <form onSubmit={submit} noValidate className="auth-form">
          <div className="auth-field">
            <label htmlFor="email" className="auth-label">Email</label>
            <input id="email" name="email" type="email" autoComplete="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" className="auth-input" autoFocus />
          </div>
          <div className="auth-field">
            <label htmlFor="pin" className="auth-label">Passcode</label>
            <input id="pin" name="pin" inputMode="numeric" pattern="[0-9]*" autoComplete="new-password" value={formData.pin} onChange={handleChange} placeholder="Create a passcode" className="auth-input" />
          </div>
          <div className="auth-field">
            <label htmlFor="confirmPin" className="auth-label">Confirm Passcode</label>
            <input id="confirmPin" name="confirmPin" inputMode="numeric" pattern="[0-9]*" autoComplete="new-password" value={formData.confirmPin} onChange={handleChange} placeholder="Confirm your passcode" aria-invalid={touched && formData.pin !== formData.confirmPin} className={`auth-input ${touched && formData.pin !== formData.confirmPin ? 'auth-input-error' : ''}`} />
            {touched && formData.pin !== formData.confirmPin && (
              <div className="auth-error">Passcodes do not match</div>
            )}
          </div>
          {error && <div className="auth-error">{error}</div>}
          <div className="auth-footer">
            <div className="auth-switch">
              Already have an account? <a href="#" onClick={(e) => { e.preventDefault(); onToggleLogin(); }} className="auth-link">Sign in</a>
            </div>
            <div className="auth-actions">
              <button type="submit" disabled={submitting || !valid} className="auth-btn auth-btn-primary">
                {submitting ? 'Creating account…' : 'Create account'}
              </button>
            </div>
          </div>
        </form>

        <div className="auth-note">By creating an account, you agree to our terms and conditions</div>
      </div>
    </div>
  )
}
